/** * Created by lobin on 2020/9/18. */
<template>
  <div class="forbiden">
    <h2>设备未注册</h2>
    <van-button type="primary" @click="goToCondig">前往设置</van-button>
    <van-button type="primary" @click="play">播放测试</van-button>
  </div>
</template>

<script type="text/babel">
import { playVoice } from "../utils";
export default {
  data() {
    return {};
  },
  methods: {
    goToCondig() {
      // uni.reLaunch({ url: "/pages/center/index" });
    },
    play() {
      playVoice("customPick");
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.forbiden {
  margin-top: 20%;
  text-align: center;
}
</style>
